import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewListIcon from "@mui/icons-material/ViewList";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

function ScheduleHeader({ firstName, viewMode, onViewChange, loading, onRefresh, onOpenFullSchedule }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { sm: "center" },
        justifyContent: "space-between",
        gap: 1.5,
        mb: 1.5
      }}
    >
      <Typography variant="h5" fontWeight={600}>
        {firstName ? `Hi ${firstName}, here's your schedule` : "Your schedule"}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={viewMode}
          onChange={onViewChange}
          sx={{
            bgcolor: "action.hover",
            borderRadius: 999,
            p: 0.5,
            gap: 0.5,
            "& .MuiToggleButtonGroup-grouped": {
              border: 0,
              borderRadius: "999px !important",
              px: 1.75,
              py: 0.5,
              color: "text.secondary",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "transparent", color: "text.primary" },
              "&.Mui-selected": {
                bgcolor: "primary.main",
                color: "primary.contrastText",
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                "&:hover": { bgcolor: "primary.dark", color: "primary.contrastText" }
              }
            }
          }}
        >
          <ToggleButton value="list">
            <ViewListIcon fontSize="small" sx={{ mr: 0.5 }} />
            List
          </ToggleButton>
          <ToggleButton value="week">
            <CalendarViewWeekIcon fontSize="small" sx={{ mr: 0.5 }} />
            Week
          </ToggleButton>
        </ToggleButtonGroup>
        <Button
          size="small"
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh
        </Button>
        {/* Senior trainers only — the server decides, this just shows the door. */}
        {onOpenFullSchedule && (
          <Button size="small" variant="outlined" startIcon={<CalendarMonthIcon />} onClick={onOpenFullSchedule} sx={{ whiteSpace: "nowrap", width: { xs: "100%", sm: "auto" } }}>
            Club schedule
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default ScheduleHeader;
